import React from 'react';
import I18n from 'i18n-js';

import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { useMediaQuery } from '@reverbdotcom/cadence/components';

import Overview from './Overview';
import Pending, { IPendingProps } from './Pending';
import { PayoutMethodACHProps } from './PayoutMethod';
import WalletMarketingCallout from './WalletMarketingCallout';
import {
  PayoutMethodQuery,
  core_apimessages_DirectCheckoutProfile_PayoutMethod,
} from '@reverbdotcom/commons/src/gql/graphql';

export const WALLET_MARKETING_DISMISSED_KEY = 'wallet_marketing_dismissed';
export const WALLET_MARKETING_EXPIRATION_DATE = '2026-01-01';

interface IProps extends IPendingProps, PayoutMethodACHProps {}

export default function Payouts({
  pendingAmountsByCurrency = [],
  accountNumberLastFour = '',
}: IProps) {
  const [showCallout, setShowCallout] = React.useState(false);
  const { data } = useQuery<PayoutMethodQuery>(PAYOUT_METHOD_QUERY);
  const { myDirectCheckoutProfile } = data || {};
  const { payoutMethodEnum } = myDirectCheckoutProfile || {};
  const isMobile = useMediaQuery('mobile');
  const showCalloutInOverview = isMobile || pendingAmountsByCurrency.length === 0;

  React.useEffect(() => {
    const payoutMethodWallet = payoutMethodEnum === core_apimessages_DirectCheckoutProfile_PayoutMethod.WALLET;
    const walletMarketingDismissed = localStorage.getItem(WALLET_MARKETING_DISMISSED_KEY) === 'true';
    const walletMarketingExpired = new Date() >= new Date(WALLET_MARKETING_EXPIRATION_DATE);

    setShowCallout(!(!payoutMethodEnum || payoutMethodWallet || walletMarketingDismissed || walletMarketingExpired));
  }, [payoutMethodEnum]);

  function handleOnDismiss(e: React.MouseEvent) {
    e.stopPropagation();
    localStorage.setItem(WALLET_MARKETING_DISMISSED_KEY, 'true');
    setShowCallout(false);
  }

  return (
    <div className="earnings-payouts">
      <Overview
        payoutMethodEnum={payoutMethodEnum}
        accountNumberLastFour={accountNumberLastFour}
      >
        {showCallout && showCalloutInOverview && (
          <WalletMarketingCallout onDismiss={(e) => handleOnDismiss(e)} />
        )}
      </ Overview>
      <Pending pendingAmountsByCurrency={pendingAmountsByCurrency}>
        {showCallout && !showCalloutInOverview && (
          <WalletMarketingCallout onDismiss={(e) => handleOnDismiss(e)} />
        )}
      </ Pending>
      <hr className="mtb-10" />
      <div className="earnings-payouts__payout-history__title">
        {I18n.t('earnings.payouts.history.title')}
      </div>
    </div>
  );
}

export const PAYOUT_METHOD_QUERY = gql(`
  query PayoutMethod {
    myDirectCheckoutProfile {
      payoutMethodEnum
    }
  }
`);
